
// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
    install(Vue, options) {
        Vue.prototype.getPdf = function (el_name = '#pdfDom') {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.1)'
          });
            var title = this.htmlTitle  //DPF标题
            // const pageWidth = 595.28 - 40 // A4纸的宽高 减去左右边距
            // const pageHeight = 841.89
            const refDom = document.querySelector(el_name).getBoundingClientRect()
            const pageWidth = 595.28 - 40 // A4纸的宽高 减去左右边距
            const pageHeight = 841.89
            // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
       
            html2Canvas(document.querySelector(el_name), {
              allowTaint: true,
              taintTest: false,
              useCORS: true,
              async: true,
              scale: '1', // 放大倍数
              dpi: '192', // 精度
              scrollY: refDom.top, // 关键代码
              height: refDom.height + 100 // 加高度，避免截取不全,
            }).then(canvas => {
              const contentWidth = canvas.width
              const contentHeight = canvas.height
              const pageData = canvas.toDataURL('image/jpeg/png', 1)
              const PDF = new JsPDF('', 'pt', 'a4') // , true
              const pageNum = Math.ceil((refDom.height + 50) / contentHeight); // 总页数
              console.log('pageNum',pageNum);
              // canvas图片的高
              const imgHeight = pageWidth / contentWidth * contentHeight // canvas的宽与PDF的宽比列一样的时候，canvas的高缩放后的值
       
              let leftHeight = imgHeight 
              console.log('leftHeight',leftHeight);
              let position = 0
              // 如果图片的高小于A4纸的高，不分页
              if (leftHeight < pageHeight) {
                PDF.addImage(pageData, 'JPEG', 20, 0, pageWidth, imgHeight)
              } else {
                // 分页
                // let index = 0
                while (leftHeight > 0) {
                  // console.log(leftHeight, '每一页的高度', imgHeight, index)
                  // index++
                  // addImage(stream, startX, startY, width, height)
                  // stream:图片流
                  // (startX,startY)图片的放置的开始点
                  console.log('pageData',pageData);
                  PDF.addImage(pageData, 'JPEG', 20, position, pageWidth, imgHeight)
                  leftHeight = leftHeight - pageHeight
                  position -= pageHeight
                  if (leftHeight > 0) {
                    PDF.addPage()
                  }
                }
              }
              PDF.save(`${title}.pdf`) // 保存PDF
              this.isShow = false
              loading.close();
              return PDF.output('datauristring')
            })
        }
    }
}
